export enum SchedulerFrequency {
  Dayly = 0,
  Weekly = 1,
  Monthly = 2,
  Quarterly = 3,
  SemiAnnuality = 4,
  Annuality = 5,
}

interface SubscriptionScheduleBase {
  frequency: SchedulerFrequency;
  time: string;
  day: number | null;
  month: number | null;
}

interface SubscriptionScheduleDaily extends SubscriptionScheduleBase {
  frequency: SchedulerFrequency.Dayly;
  day: null;
  month: null;
}
interface SubscriptionScheduleWeekly extends SubscriptionScheduleBase {
  frequency: SchedulerFrequency.Weekly;
  day: number;
  month: null;
}
interface SubscriptionScheduleMonthly extends SubscriptionScheduleBase {
  frequency: SchedulerFrequency.Monthly;
  day: number;
  month: null;
}
interface SubscriptionScheduleQuarterly extends SubscriptionScheduleBase {
  frequency: SchedulerFrequency.Quarterly;
  day: number;
  month: number;
}
interface SubscriptionScheduleSemiAnnuality extends SubscriptionScheduleBase {
  frequency: SchedulerFrequency.SemiAnnuality;
  day: number;
  month: number;
}
interface SubscriptionScheduleAnnuality extends SubscriptionScheduleBase {
  frequency: SchedulerFrequency.Annuality;
  day: number;
  month: number;
}

export type SubscriptionSchedule =
  | SubscriptionScheduleDaily
  | SubscriptionScheduleWeekly
  | SubscriptionScheduleMonthly
  | SubscriptionScheduleQuarterly
  | SubscriptionScheduleSemiAnnuality
  | SubscriptionScheduleAnnuality;
